import React from 'react';
import '../Styles/contact.css'; 

function Contact() {
  return (
    <div className="cta-container" id='contact'>
      <div className="cta-content">
        <div className="cta-text">
          <h2 className="cta-title">Advance your career with us</h2>
          <p className="cta-subtitle">Join us and become an InfoVisionary today!</p>
        </div>
        <button className="cta-button">connect</button>
      </div>
    </div>
  );
}

export default Contact;
